import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.profile;

export const profileSelector = createSelector(getState, (state) => state.profile);
export const isLoadingProfileSelector = createSelector(
  getState,
  (state) => state.isLoadingProfile
);
export const isUpdatingProfileSelector = createSelector(
  getState,
  (state) => state.isUpdatingProfile
);
